function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { Fragment } from 'react';
import { H3 } from '@finect/tabular-core/Headings';
import { TextButton } from '@finect/tabular-core/TextButton';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { arrayOfObjectsToObject } from '@finect/front-utils/arrayOfObjectsToObject';
import { objectToArrayOfObjects } from '@finect/front-utils/objectToArrayOfObjects';
import { BubbleWithIcon } from '../../../components';
import { Inner, TitleBlock, ContentBlock, FooterBlock } from './partials';
var TitleElement = function TitleElement(_ref) {
  var block = _ref.block;
  var _block$props = block.props,
    bubble = _block$props.bubble,
    text = _block$props.text;
  return React.createElement(Fragment, null, bubble ? React.createElement(BubbleWithIcon, {
    size: "large",
    type: bubble || 'success'
  }) : null, React.createElement(TitleBlock, null, React.createElement(H3, null, text)));
};
var TextElement = function TextElement(_ref2) {
  var block = _ref2.block;
  var text = block.props.text;
  return React.createElement(ContentBlock, null, React.createElement(Paragraph, {
    light: true
  }, text));
};
var CallToActionElement = function CallToActionElement(_ref3) {
  var block = _ref3.block;
  var _block$props2 = block.props,
    text = _block$props2.text,
    onClick = _block$props2.onClick;
  return React.createElement(FooterBlock, null, React.createElement(TextButton, {
    primary: true,
    width: "auto",
    onClick: onClick
  }, React.createElement("span", null, text), React.createElement(ArrowRight, null)));
};
var ELEMENTS = {
  title: {
    component: TitleElement
  },
  text: {
    component: TextElement
  },
  cta: {
    component: CallToActionElement
  }
};
export var ThankYou = function ThankYou(_ref4) {
  var resultPage = _ref4.resultPage,
    pillProps = _ref4.pillProps;
  var components = resultPage.components;
  return React.createElement(Inner, null, components.map(function (block, key) {
    var element = ELEMENTS[block.name];
    var BlockComponent = element.component;
    var propsList = objectToArrayOfObjects(block.props, 'propName', 'propValue');
    var processed = propsList.map(function (prop) {
      var propValue = prop.propValue;
      if (typeof propValue === 'function') {
        return _objectSpread(_objectSpread({}, prop), {
          propValue: propValue(pillProps)
        });
      }
      return prop;
    });
    var processedBlock = _objectSpread(_objectSpread({}, block), {
      props: arrayOfObjectsToObject(processed, 'propName', 'propValue')
    });
    return React.createElement(Fragment, {
      key: key
    }, React.createElement(BlockComponent, {
      block: processedBlock,
      pillProps: pillProps
    }));
  }));
};